module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADuSURBVEiJ7ZYxTgMxEABnoxRXnsRDoMgDEomCgo6GMrzh0vKbSNBQp8wX4BfQ0d0VSEMRpwDZnAS4iW4qSz7v3Fq2dwFQF+pO7c3TUUDtCmv6FHMBEGmwB56ALfCRifccEe8FUQtcZKYa4Ba4AVah7oC3iFiX/vovqFvgjJTiZQ1JEl2p/YxDirnt+i8GoJlVFHxhEv0edZPuQq34rbqpFX9i4gdSPal9vDtSkVpWFC1VT+8JOk3RAMwrOhpgODYnrxFxV8OiPgDtHLgH9irAI4cMv/My0m6dZ6YaYA1cA6vjx2MNZLGepHo22kB+AqyK7S9eGwqRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hk-video/full-sreen.png
// module id = WygO
// module chunks = 1